import React, {useEffect, useState}from 'react';
import i18n from '../../locales/index';
import { Row, Col, Container, Image } from 'react-bootstrap'
import './index.css'
import TitleBold from '../../components/Text/TitleBold';
import TitleLight from '../../components/Text/TitleLight';
import MainStyles from '../../styles/MainStyles';
import Speedometer from '../../assets/images/performance.svg'
import BadgeIcon from '../BadgeIcon';
import { formatNumber } from '../../services/utils';
import TextError from '../Text/TextError';
import BlueButtonOutlineDark from '../Buttons/BlueButtonOutlineDark';
import ModalDetails from '../ModalDetail';
import {  getWarrantySeal } from '../../services/HomeService';
import BlueButton from '../Buttons/BlueButton';
import BadgeOK from '../../assets/images/guaranteeStampAvaliable.svg'
import BadgeError from '../../assets/images/guaranteeStampUnavaliable.svg'
import moment from 'moment';
import iconOK from '../../assets/images/guaranteeStampAvaliable.svg'
import iconError from '../../assets/images/guaranteeStampUnavaliable.svg'

const BadgeStatus = ({ modelDetail, km_actual, isStampActive,isValidYear, warranty }) => {
  const [show, setShow] = useState(false);
  const [guaranteeStamp, setGuaranteeStamp] = useState(false);
  const [warratyDetail, setWarrantyDetail] = useState({})
  const [isAmarok, setIsAmarok] = useState(true)
  useEffect(()=>{
    async function fetch() {          
          setGuaranteeStamp((warranty.typeCardToShow == "warranty-available" || warranty.typeCardToShow == "stamp-available") ?true:false)
          setWarrantyDetail(warranty)
          setIsAmarok(warranty.isInAmarokWithKmLimitationList)        
    }
    fetch()
  },[])

  const cardDetail =  () => {
    switch (warratyDetail.typeCardToShow) {
      case "warranty-available" : 
        return i18n.t('badge_status.infoGuaranteeStamp')
      
        case "warranty-unavailable" : 
        return i18n.t('badge_status.maintenanceNoK')
        
        case "stamp-available" :         
        return i18n.t('badge_status.dataAvailableStamp')
        
        case "stamp-unavailable" : 
        return i18n.t('badge_status.dataUnavailableStamp')

        case "unavailable" : 
        return i18n.t('badge_status.dataUnavailableStamp')
    }
  }
  const cardTitle =  () => {
    switch (warratyDetail.typeCardToShow) {
     
      case "warranty-available" : 
        return i18n.t('badge_status.availableGuaranteeStamp')
      
        case "warranty-unavailable" : 
        return i18n.t('badge_status.unavailableGuaranteeStamp')
        
        case "stamp-available" : 
          return i18n.t('badge_status.serviceCertificate')
        
        case "stamp-unavailable" : 
          return i18n.t('badge_status.serviceCertificate')

        case "unavailable" : 
        return i18n.t('badge_status.serviceCertificate')
    }
  }
  const messageModal =  () => {
    switch (warratyDetail.typeCardToShow) {
            
        case "stamp-unavailable" :         
        return i18n.t('badge_status.modalnOKCertServicePt1')

        case "stamp-available" :         
        return i18n.t('badge_status.modalOKavaliableStamp-finishWarrantyPt1')
     
        case "warranty-unavailable" :
          return i18n.t('badge_status.modalOK')
        
        default : 
        return i18n.t('badge_status.modalOK')

    }
  }

 
  const cardTitleGuaranteeText = guaranteeStamp
    ? i18n.t('badge_status.availableGuaranteeStamp')
    : i18n.t('badge_status.unavailableGuaranteeStamp');
  
  
  var warrantyPeriod = i18n.t('badge_status.warrantyPeriod')
  var warrantyPeriodDate;

  if (warratyDetail){
      warrantyPeriodDate =  moment(warratyDetail.warrantyEndsIn).format('DD/MM/YYYY');
  }
  
  const cardDescriptionGiaranteeText = i18n.t('badge_status.infoGuaranteeStamp')
  var textModal =  i18n.t('badge_status.modalOK') 


  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <Container fluid="md">
      <ModalDetails 
        show={show} 
        handleClose={handleClose} 
        guaranteeStamp={guaranteeStamp} 
        detail={warratyDetail}
        image={
          guaranteeStamp ?
          <Image src={BadgeOK} alt='tool' className='icon-ok' style={{marginTop:"-60px", marginLeft:"200px"}} /> 
          :
          <Image src={BadgeError} alt='tool' className='icon-ok' style={{marginTop:"-60px", marginLeft:"200px"}} /> 
        }
        infoPeriod={<TitleLight
                      ownClass={"modal-text"}
                      text={(isAmarok && km_actual < 100000) ? i18n.t('badge_status.messageIsAmarok') : !guaranteeStamp ? '' : warrantyPeriod + warrantyPeriodDate}
                      color={MainStyles.colors.black}
                      size={'xsmall'} />}
        text={
          <TitleLight
          ownClass={"modal-text"}
          text={messageModal()}
          color={MainStyles.colors.black}
          size={'xsmall'} />
        }
        button={
          <BlueButton                
                text={"Ok, entendi"}
                isRounded={true}
                marginTop
                onClick={handleClose}
                
            /> 
        }
      />
      <Row className={'mainRow'}>
        <Col md={{ span: 6, offset: 0 }} sm={{ span: 5, offset: 0 }} className={km_actual ? 'colLeft' : ''}>
          { km_actual &&
            <Row>
              <Col md={{ span: 1, offset: 2 }} sm={{ span: 1, offset: 0 }} xs={{ span: 1, offset: 0 }}>
                <Image
                  style={{ width: '46px', height: '46px' }}
                  src={Speedometer}
                />
              </Col>
              <Col md={{ span: 7, offset: 1 }} sm={{ span: 9, offset: 1 }} xs={{ span: 7, offset: 1 }}>
                <TitleBold
                  text={i18n.t('badge_status.km_actual')}
                  color={MainStyles.colors.black}
                  size={'small'} />

                <TitleLight
                  text={`${formatNumber(km_actual)} ${i18n.t('general.km')}`}
                  color={MainStyles.colors.black}
                  ownClass={'car_km_value'}
                  size={'bigger'} />
              </Col>
            </Row>
          }
        </Col>

        <Col md={{ span: 5, offset: 1 }} sm={{ span: 6, offset: 1 }} className='colRight'>
         
            {/* {!isValidYear ? */}
              <Row>
                <Col md={1} xs={{ span: 1, offset: 0 }}>
                <div className='badge-icon-container'>
                    {
                      guaranteeStamp?
                      <Image src={iconOK} alt='tool' className='icon-ok'/> :
                      <Image src={iconError} alt='tool' className='icon-ok'/> 
                    }
                </div>
                </Col>
                <Col md={{ size: 8, offset: 1 }} sm={{ span: 9, offset: 1 }} xs={{ span: 8, offset: 1 }}>
                  
                  
                  <Row>
                    <TitleLight
                    text={( isAmarok && km_actual > 100000) ? i18n.t('badge_status.unavailableAmarokStamp') : cardTitle()}
                    color={MainStyles.colors.black}
                    ownClass={'car_km_value'}
                    size={'bigger'} />
                    <TitleLight
                    text={cardDetail()}
                    color={MainStyles.colors.black}
                    size={'small'} />
                    <BlueButtonOutlineDark
                      text={"Ver detalhes"}
                      isRounded={true}
                      marginTop
                      onClick={handleShow}
                    />
                  </Row>
                  
                 
                </Col>
                </Row>

        </Col>
      </Row>
    </Container>
  )
}

export default BadgeStatus